import styles from './EnachCard.module.scss';
import AutopayNotSetup from './EnachCardText/AutopayNotSetup';
import AutopayInProgress from './EnachCardText/AutopayInProgress';
import AutopaySetup from './EnachCardText/AutopaySetup';
import AutopayFailed from './EnachCardText/AutoPayFailed';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import AutopayRevoked from './EnachCardText/AutoPayRevoked';
import AutopayExpired from './EnachCardText/AutoPayExpired';
import { UnifiedMandateStatus } from '@cp/src/reducers/commonSlice';
import {
  enachExpiredStatuses,
  enachNotSetupStatuses,
  enachRevokedStatuses,
  enachSetupStatuses
} from './EnachCardText/const';
import dayjs from 'dayjs';
import { DateFormat } from '@cp/src/utils/DateHelper';

interface EnachCardProps {
  isMandateStatusSuccess: boolean;
  enachCardText: string;
  enachCardDate: string;
  mandateInProgress: boolean;
  isReminderTypePreDue?: boolean;
  isRepaymentFailureDetailsNull: boolean;
  date: string;
}

const EnachCard = (props: EnachCardProps) => {
  const { enachCardText, enachCardDate, isRepaymentFailureDetailsNull, date } = props;

  const checkDateParsable = !!(enachCardDate && !isNaN(Date.parse(enachCardDate)));

  const unifiedMandateStatus = useSelector(
    (state: RootState) =>
      state.common.humanReminderCustomerDetails?.humanReminderResponse?.loanDetails
        ?.unifiedMandateStatus
  );

  const existingMandateStatus = useSelector(
    (state: RootState) =>
      state.common.humanReminderCustomerDetails?.humanReminderResponse?.loanDetails?.mandateStatus
  );

  const mandateStatus = unifiedMandateStatus || existingMandateStatus;

  const isAutoPayExpired = enachExpiredStatuses.includes(mandateStatus);
  const isAutoPayRevoked = enachRevokedStatuses.includes(mandateStatus);
  const isAutoPaySetup = enachSetupStatuses.includes(mandateStatus);
  const isAutoPayNotSetup = enachNotSetupStatuses.includes(mandateStatus);
  // const isAutopayFailed = mandateStatus === UnifiedMandateStatus.FAILED;
  const isAutoPayInProgress = mandateStatus === UnifiedMandateStatus.IN_PROGRESS;

  const nextEnachDate = dayjs(date).format(DateFormat.LONG_DATE_WITH_DAY);

  const autopayRendererComponent = () => {
    if (isAutoPaySetup) {
      if (isRepaymentFailureDetailsNull) {
        return <AutopaySetup />;
      } else {
        return (
          <AutopayFailed
            date={nextEnachDate}
            enachCardText={enachCardText}
            enachCardDate={enachCardDate}
            checkDateParsable={checkDateParsable}
          />
        );
      }
    } else if (isAutoPayNotSetup) {
      return <AutopayNotSetup />;
    } else if (isAutoPayRevoked) {
      return <AutopayRevoked />;
    } else if (isAutoPayExpired) {
      return <AutopayExpired />;
    } else if (isAutoPayInProgress) {
      return <AutopayInProgress />;
    } else {
      return null;
    }
  };

  return <div className={styles.enachCardContainer}>{autopayRendererComponent()}</div>;
};

export default EnachCard;
